import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import './IECStyles.css';
import { useDispatch, useSelector } from 'react-redux';
import { getIECImagesAPICall } from '../../../api/iecAcitivityAPI';
import { Tooltip } from '@mui/material';


export const IECActivitiesFormDetails = () => {
    const [labelList, setLabelList] = useState<any[]>([]);
    const dispatch: any = useDispatch();
    const { storeIecFormData } = useSelector((state: any) => state.iecActivity);

    useEffect(() => {
        if (storeIecFormData && storeIecFormData.data && storeIecFormData.data.length > 0) {
            const formData = storeIecFormData.data[0];
            dispatch(getIECImagesAPICall(formData.iecId, formData.imagePaths))
            const activity = formData.activityType;
            switch (activity) {
                case "Bank Visit":
                    {
                        setLabelList([
                            {
                                "Season": formData.season,
                                "Select Year": formData.year,
                                "State": formData.stateName,
                                "District": formData.districtName,
                                "Tehsil / Taluka / Subdistrict / Block": formData.blockName,
                                "Village Name": formData.villageName,
                                "Type of Activity": formData.activityType,
                                "Activity Date": formData.activity_date?.slice(0,10),
                                "Total Female Farmers Attended": formData.female_count ?? '',
                                "Total Farmers Attended": formData.farmer_count ?? '',
                                "Bank Name": formData.bankName,
                                "Branch Name": formData.branchName,
                                "Branch Manager Name": formData.branchManagerName,
                                "Branch Manager Phone NU": formData.branchManagerMobileNumber,
                                "Branch Email ID": formData.branchEmailId,
                                "Count of KCC A/C Holder": formData.countOfKccAccHolder,
                                "Total Expected Premium": formData.totalExpectedPremium,
                                "Comments": formData.comments
                            }
                        ]);
                    }
                    break;

                case "Market Campaign":
                    {
                        setLabelList([
                            {
                                "Season": formData.season,
                                "Select Year": formData.year,
                                "State": formData.stateName,
                                "District": formData.districtName,
                                "Tehsil / Taluka / Subdistrict / Block": formData.blockName,
                                "Village Name": formData.villageName,
                                "Officers Mobile Number": formData.mobileNumber,
                                "Type of Activity": formData.activityType,
                                "Activity Date": formData.activity_date?.slice(0,10),
                                "Total Female Farmers Attended": formData.female_count ?? '',
                                "Total Farmers Attended": formData.farmer_count ?? '',
                                "Market Campaign": formData.marketCampaign,
                                "Meeting type": formData.meeting_type,
                                "Comments": formData.comments
                            }
                        ]);
                    }
                    break;

                case "Govt office visit":
                    {
                        setLabelList([
                            {
                                "Season": formData.season,
                                "Select Year": formData.year,
                                "State": formData.stateName,
                                "District": formData.districtName,
                                "Tehsil / Taluka / Subdistrict / Block": formData.blockName,
                                "Village Name": formData.villageName,
                                "Type of Activity": formData.activityType,
                                "Activity Date": formData.activity_date?.slice(0,10),
                                "Total Female Farmers Attended": formData.female_count,
                                "Total Farmers Attended": formData.farmer_count,
                                "Govt. Office": formData.govtOffice,
                                "Name of Officer": formData.officerName,
                                "Officers Mobile Number": formData.officerMobileNumber,
                                "Office Email ID": formData.officerEmailId,
                                "Comments": formData.comments
                            }
                        ]);
                    }
                    break;

                case "CSC Center Visit":
                    {
                        setLabelList([
                            {
                                "Season": formData.season,
                                "Select Year": formData.year,
                                "State": formData.stateName,
                                "District": formData.districtName,
                                "Tehsil / Taluka / Subdistrict / Block": formData.blockName,
                                "Village Name": formData.villageName,
                                "Type of Activity": formData.activityType,
                                "Activity Date": formData.activity_date?.slice(0,10),
                                "Total Female Farmers Attended": formData.female_count,
                                "Total Farmers Attended": formData.farmer_count,
                                "Center ID": formData.centerId,
                                "Name": formData.name,
                                "Phone Number": formData.phoneNumber,
                                "Center Email ID": formData.centerEmailId,
                                "Comments": formData.comments
                            }
                        ]);
                    }
                    break;
            }

        }
    }, [storeIecFormData, dispatch]);

    if (!labelList[0]) {
        return null;
    }

    return (
        <Row className='mx-0'>
            <div className='iec-form-details-container px-0'>
                <p className="section-header">Activity Details</p>
                <Row className="py-3 mx-2">
                    {Object.keys(labelList[0]).map((value: string, index: number) => {
                        return (
                            <Col xs={3} md={3} key={`value-${index}`} className="mb-3">
                                <p className="header-key">{value}</p>
                                <p className="details-key">
                                    <Tooltip
                                        title={labelList[0][value]}
                                        placement="bottom-start"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: 'black'
                                                }
                                            }
                                        }}
                                    >
                                        {(labelList[0][value]?.length > 0 || (!isNaN(labelList[0][value]) && labelList[0][value] !== null) ) ? labelList[0][value] : 'N/A'}
                                    </Tooltip>
                                </p>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </Row>
    );
};
